import * as React from 'react';
import { PdsIconArrowRight as PdsIconArrowRightElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconArrowRight = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-arrow-right',
  elementClass: PdsIconArrowRightElement,
  react: React,
});
